<section
  class="set-security-questions-section container-fluid sts-section sts-form">

  <app-sts-section-header *ngIf="!inConfirmState" key="sts-choose-questions-header" [errors]="errors">Choose security questions
  </app-sts-section-header>
  <app-sts-section-header *ngIf="inConfirmState" key="sts-confirm-questions-header" [errors]="errors">Confirm security questions
  </app-sts-section-header>

  <app-sts-section-body *ngIf="!inConfirmState" key="sts-preselected-questions-body">
    <p>Please choose three different security questions from the drop-down list
      below and provide the answers.</p>
    <p>These questions will be used if you forget your password and need to
      reset it, so your answers should be one word and
      easy to remember.</p>
    <p>Select Next when you are finished.</p>
  </app-sts-section-body>

  <app-sts-section-body *ngIf="inConfirmState" key="sts-preselected-questions-confirm-body">
    <p>Review the security questions and select Save if you want to keep them. </p>
    <p>Select Back if you want to change your questions</p>
  </app-sts-section-body>


  <form [formGroup]="qAndAForm" class="sts-form" (ngSubmit)="onSubmit()" autocomplete="off">

      <div class="row">
        <div class="col-24">
          <div class="sts-object">
            <ng-container class="q-and-a-box sts-form-row"
                *ngFor="let qAndA of qAndAList; let i = index;">
              <div class="row sts-label-row">
                <div class="col-24">
                <!--<div [ngClass]="{'answer-error': !getQuestionValidity(qAndA)}" class="btn-group sts-dropdown-container" dropdown>-->
                  <div class="btn-group sts-dropdown-container" *ngIf="!inConfirmState">
                    <div class="btn-group" dropdown>
                      <span dropdown>
                        <a href id="basic-link" dropdownToggle (click)="false"
                           aria-controls="basic-link-dropdown" class="sts-dropdown-link clearfix">
                           <span class="pull-left sts-question-text bold">{{ getQuestionText(qAndA.question) }}</span>
                           <span *ngIf="!inConfirmState"
                              class="pull-right change-button animate-all">
                              (<span><span app-sts-cms-txt key="sts-change-drop-down-text">modify</span> 
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill svgCaret" viewBox="0 0 16 16">
                                  <path d="M3.626 6.832A.5.5 0 014 6h8a.5.5 0 01.374.832l-4 4.5a.5.5 0 01-.748 0l-4-4.5z"></path>
                                </svg>
                              </span>)
                              </span>
                        </a>
                        <ul id="basic-link-dropdown" *dropdownMenu class="dropdown-menu"
                            role="menu" aria-labelledby="basic-link">
                            <li role="menuitem"
                              *ngFor="let question of (questions | uniqueQuestions: qAndA.hiddenQuestionIds)">
                              <a class="dropdown-item" *ngIf="!inConfirmState"
                                (click)="setQuestion(qAndA, question)">{{ getQuestionText(question) }}</a>
                            </li>
                        </ul>
                      </span>  
                    </div>             
                  </div>

                  <span class="pull-left sts-question-text bold" *ngIf="inConfirmState">{{getQuestionText(qAndA.question) }}</span>
                  <!--<div class="field-error-box" [ngClass]="{'show': !getQuestionValidity(qAndA)}">
                    <span app-sts-cms-txt key="{{ qAndA?.question?.error?.code }}">{{ qAndA?.question?.error?.description }}</span>
                  </div>-->
                </div>
              </div>
              <div class="sts-input-row">
                <div>
                  <input [ngClass]="{'answer-error has-errors': !getAnswerValidity(qAndA)}"
                          pattern=".{3,}" required
                          *ngIf="!inConfirmState" type="text" class="sts-textbox"
                          formControlName="{{ qAndA.internalId }}"
                          name="answer" (blur)="onAnswerBlur(qAndA)" />
                  <span *ngIf="inConfirmState">{{ qAndA.answer }}</span>
                </div>
                <div [ngClass]="{'show': !getAnswerValidity(qAndA)}"
                      class="field-error-box">
                  <span *ngIf="!getAnswerValidity(qAndA)" app-sts-cms-txt key="{{ qAndA.error.code }}"></span>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="row">
          <div class="col-24">

            <button *ngIf="!inConfirmState" class="sts-btn other-sts-btn"  type="button"
                    app-sts-cms-txt key="sts-cancel-button"
                    (click)="onContinue()">Cancel
            </button>
            <button *ngIf="inConfirmState" class="sts-btn other-sts-btn" type="button"
                    (click)="toggleConfirmState()"
                    [disabled]="formSubmitSuccess"
                    [ngClass]="{'disabled': formSubmitSuccess}"
                    app-sts-cms-txt key="sts-cancel-button-label">Cancel
            </button>


            <button *ngIf="!inConfirmState" [disabled]="!qAndAForm.valid"
                    [ngClass]="{'disabled': !qAndAForm.valid}" class="sts-btn"
                    type="button" (click)="initialSave()" app-sts-cms-txt
                    key="sts-next-button-label">Next
            </button>

            <app-sts-button *ngIf="inConfirmState"
                    key="sts-confirm-button-label"
                    [disabled]="formSubmitSuccess">Confirm
            </app-sts-button>


            <button *ngIf="!newUserFlow && formSubmitSuccess" class="sts-btn"
                    type="button" (click)="onContinue()" app-sts-cms-txt
                    key="sts-continue">Continue
            </button>

          </div>
        </div>

  </form>

</section>
